import { SsoType } from '@tribeplatform/gql-client/types'

import {
  AppleLogo,
  DiscordLogo,
  FacebookLogo,
  GoogleLogo,
  LinkedInLogo,
  SlackLogo,
  TwitterLogo,
} from '../../icons'

export const SsoIcon = {
  [SsoType.google]: <GoogleLogo />,
  [SsoType.facebook]: <FacebookLogo />,
  [SsoType.linkedin]: <LinkedInLogo />,
  [SsoType.Discord]: <DiscordLogo />,
  [SsoType.Slack]: <SlackLogo />,
  [SsoType.Apple]: <AppleLogo />,
  [SsoType.Twitter]: <TwitterLogo />,
}
